export const ErrorCode = {
  // Generic
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  BAD_REQUEST: 'BAD_REQUEST',
  NOT_FOUND: 'NOT_FOUND',
  FORBIDDEN: 'FORBIDDEN',
  CONFLICT: 'CONFLICT',
  RATE_LIMITED: 'RATE_LIMITED',

  // Auth
  AUTH_MISSING_TOKEN: 'AUTH_MISSING_TOKEN',
  AUTH_INVALID_TOKEN: 'AUTH_INVALID_TOKEN',
  AUTH_TOKEN_EXPIRED: 'AUTH_TOKEN_EXPIRED',
  AUTH_INVALID_INIT_DATA: 'AUTH_INVALID_INIT_DATA',
  AUTH_INVALID_CREDENTIALS: 'AUTH_INVALID_CREDENTIALS',

  // Clubs
  CLUB_NOT_FOUND: 'CLUB_NOT_FOUND',
  CLUB_NOT_PUBLISHED: 'CLUB_NOT_PUBLISHED',

  // Chapters
  CHAPTER_NOT_FOUND: 'CHAPTER_NOT_FOUND',
  CHAPTER_NOT_PUBLISHED: 'CHAPTER_NOT_PUBLISHED',
  CHAPTER_LOCKED: 'CHAPTER_LOCKED',

  // Media
  MEDIA_UNSUPPORTED_FORMAT: 'MEDIA_UNSUPPORTED_FORMAT',
  MEDIA_NOT_FOUND: 'MEDIA_NOT_FOUND',

  // Users / Access
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  ENTITLEMENT_NOT_FOUND: 'ENTITLEMENT_NOT_FOUND',
  LAST_ADMIN: 'LAST_ADMIN',
  ACCESS_DENIED: 'ACCESS_DENIED',

  // Payments
  PAYMENT_ORDER_NOT_FOUND: 'PAYMENT_ORDER_NOT_FOUND',
  PAYMENT_ALREADY_OWNED: 'PAYMENT_ALREADY_OWNED',
  PAYMENT_EMAIL_MISMATCH: 'PAYMENT_EMAIL_MISMATCH',
  PAYMENT_UNSUPPORTED_CURRENCY: 'PAYMENT_UNSUPPORTED_CURRENCY',
  PAYMENT_UNAVAILABLE: 'PAYMENT_UNAVAILABLE',
  PAYMENT_INVALID_CALLBACK: 'PAYMENT_INVALID_CALLBACK',
  PAYMENT_SIGNATURE_INVALID: 'PAYMENT_SIGNATURE_INVALID',
  PAYMENT_AMOUNT_MISMATCH: 'PAYMENT_AMOUNT_MISMATCH',
  PROMO_CODE_INVALID: 'PROMO_CODE_INVALID',
  PROMO_CODE_EXPIRED: 'PROMO_CODE_EXPIRED',
  PROMO_CODE_LIMIT_REACHED: 'PROMO_CODE_LIMIT_REACHED',
  PROMO_CODE_WRONG_CLUB: 'PROMO_CODE_WRONG_CLUB',
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];
